import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddAppoinmentsComponent } from './add-appoinments/add-appoinments.component';
import { AppoinmentsComponent } from './appoinments/appoinments.component';
import { ArticlesComponent } from './articles/articles.component';
import { ConsultationComponent } from './consultation/consultation.component';
import { EditAppoinmentComponent } from './edit-appoinment/edit-appoinment.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { HelpdeskComponent } from './helpdesk/helpdesk.component';
import { JoinvcMeetingComponent } from './joinvc-meeting/joinvc-meeting.component';
import { LabTestComponent } from './lab-test/lab-test.component';
import { MedicineOrdersComponent } from './medicine-orders/medicine-orders.component';
import { PatientHistoryComponent } from './patient-history/patient-history.component';
import { PatientComponent } from './patient.component';
import { PaymentsComponent } from './payments/payments.component';
import { PreviousRecordsComponent } from './previous-records/previous-records.component';
import { EditprofileComponent } from './profile/editprofile/editprofile.component';
import { ProfileComponent } from './profile/profile.component';
import { RecordsComponent } from './records/records.component';
import { PaymentResultComponent } from './payment-result/payment-result.component';
import { JoinMeetingComponent } from './join-meeting/join-meeting.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { LogincartComponent } from './logincart/logincart.component';
import { PaymentResultNormalComponent } from './payment-result-normal/payment-result-normal.component';
import { PrescriptionComponent } from './prescription/prescription.component';
import { ConsultationHistoryComponent } from './consultation-history/consultation-history.component';
import { DietplanInfoComponent } from './dietplan-info/dietplan-info.component';
import { PaymentFormComponent } from './payment-form/payment-form.component';


const routes: Routes = [

  {
    path:'', component:PatientComponent,
    children:[
      {
        path:'profile',
        component:ProfileComponent,
      },
      {
        path:'edit-profile',
        component:EditprofileComponent,
      },
      {
        path:'patient-history',
        component:PatientHistoryComponent,
      },
      {
        path:'previous-record',
        component:PreviousRecordsComponent,
      },
      {
        path:'records',
        component:RecordsComponent,
      },
      {
        path:'appoinment',
        component:AppoinmentsComponent,
      },
      {
        path:'add-appoinment',
        component:AddAppoinmentsComponent,
      },
      {
        path:`edit-appoinment/:id`,
        component:EditAppoinmentComponent,
      },
      {
        path:'consultation',
        component:ConsultationComponent,
      },

      {
        path: 'quick_consult',
        component: LogincartComponent,
      },
      {
        path:'joinvc-meeting/:pat_id/:cons_id',
        component:JoinvcMeetingComponent,
      },
      {
        path:'Medicine-orders',
        component:MedicineOrdersComponent,
      },
      {
        path:'Lab-Test',
        component:LabTestComponent,
      },
      {
        path:'payments',
        component:PaymentHistoryComponent,
      },
      {
        path:'paymentresult',
        component:PaymentResultComponent,
      },
      {
        path: 'paymentresultnormal',
        component: PaymentResultNormalComponent,
      },
      {
        path:'Prescription',
        component: PrescriptionComponent,
      },
      {
        path:'join-meeting',
        component:JoinMeetingComponent,
      },
      {
        path:'articles',
        component:ArticlesComponent,
      },
      {
        path:'feedback',
        component:FeedbackComponent,
      },
      {
        path:'helpdesk',
        component:HelpdeskComponent,
      },
      {
        path:'consultation-history',
        component:ConsultationHistoryComponent,
      },
      {
        path:'dietplan-info',
        component:DietplanInfoComponent,
      },
      {
        path:'payment-form/:transaction_id',
        component:PaymentFormComponent,
      },
    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PatientRoutingModule { }
